import { useEffect, useRef, type ReactNode } from "react"
import { draggable } from "@atlaskit/pragmatic-drag-and-drop/element/adapter"
import type { DragData } from "../../../dragAndDrop/dragData"

/**
 * Something the field library offers: pressed, it is added to the end of the
 * canvas; dragged, it carries `drag` to wherever the screen lets it land (see
 * eventForDrop). One that can't be added is neither. The browser draws its
 * picture while it is dragged, as nothing about it changes on the way.
 */
export function LibraryEntry({
  drag,
  className,
  disabled = false,
  onAdd,
  children,
}: {
  /** What a drag of it carries, tagged as its kind. */
  drag: DragData
  className?: string
  disabled?: boolean
  onAdd: () => void
  children: ReactNode
}) {
  const ref = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (disabled) return
    return draggable({ element: ref.current!, getInitialData: () => drag })
  }, [drag, disabled])

  return (
    <button
      ref={ref}
      type="button"
      className={className}
      disabled={disabled}
      onClick={onAdd}
    >
      {children}
    </button>
  )
}
